import { UAParser } from 'ua-parser-js';

const MINIMUM_SAFARI_VERSION_FOR_HEIC = 17;

let cachedSupport: boolean | null = null;

export function browserSupportsHeic(): boolean {
    if (cachedSupport === null) {
        cachedSupport = computeHeicSupport();
    }
    return cachedSupport;
}

/**
 * Test-only: override the cached HEIC support value.
 */
export function __setBrowserSupportsHeicForTesting(value: boolean | null): void {
    cachedSupport = value;
}

function computeHeicSupport(): boolean {
    if (typeof navigator === 'undefined') {
        return false;
    }

    const parser = new UAParser(navigator.userAgent);
    const browser = parser.getBrowser();
    const os = parser.getOS();

    const isSafariOrIOS = browser.name === 'Safari' || browser.name === 'Mobile Safari' || os.name === 'iOS';
    if (!isSafariOrIOS) {
        return false;
    }

    const majorVersion = parseMajorVersion(browser.version);
    if (majorVersion === null) {
        return false;
    }

    return majorVersion >= MINIMUM_SAFARI_VERSION_FOR_HEIC;
}

function parseMajorVersion(version: string | undefined): number | null {
    if (!version) {
        return null;
    }
    const major = Number.parseInt(version.split('.')[0], 10);
    return Number.isNaN(major) ? null : major;
}
